import { render, staticRenderFns } from "./tags-data.vue?vue&type=template&id=264142cd&"
import script from "./tags-data.vue?vue&type=script&lang=js&"
export * from "./tags-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports